// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './App.css'
// import BlogScene from './Blog.jsx'
import { Canvas } from '@react-three/fiber';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* <Canvas>
      <BlogScene/>
    </Canvas> */}
    <App />
  </React.StrictMode>
);
